package app.smartcoding.realrate.domain.model

import androidx.compose.runtime.Stable
import kotlinx.collections.immutable.ImmutableList
import kotlinx.collections.immutable.toImmutableList

@Stable
data class CreditResult(
    val nominalRate: Double = 0.0,
    val effectiveApr: Double = 0.0,
    val appreciation: Double = 0.0,
    val schedule: ImmutableList<AmortizationRow> = emptyList<AmortizationRow>().toImmutableList()
)
